import React, { useEffect, useState } from 'react';
import {
  Box, Typography, TextField, Table, TableBody, TableCell,
  TableContainer, TableHead, TableRow, Paper, Chip, Grid, Button,
  Alert,
} from '@mui/material';
import { Search as SearchIcon } from '@mui/icons-material';
import { reportsApi } from '../api/reports.api';
import LoadingSpinner from '../components/common/LoadingSpinner';

const Antitheft: React.FC = () => {
  const [data, setData] = useState<any[]>([]);
  const [loading, setLoading] = useState(false);
  const [from, setFrom] = useState('');
  const [to, setTo] = useState('');

  const load = async () => {
    setLoading(true);
    try {
      const res = await reportsApi.getAntitheft(from || undefined, to || undefined);
      setData(res.data);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  useEffect(() => { load(); }, []);

  const getStatusColor = (status: string) => {
    if (status === 'NORMAL') return 'success';
    if (status === 'EXCESO') return 'error';
    return 'warning';
  };

  const anomalies = data.filter(d => d.status !== 'NORMAL');

  return (
    <Box>
      <Typography variant="h4" gutterBottom>Control Anti-Robo</Typography>
      <Typography variant="body2" color="text.secondary" gutterBottom>
        Comparacion entre consumo esperado (segun recetas vendidas) vs consumo real (salidas de inventario)
      </Typography>

      <Paper sx={{ p: 2, mb: 3 }}>
        <Grid container spacing={2} alignItems="center">
          <Grid size={{ xs: 12, sm: 4 }}>
            <TextField fullWidth label="Desde" type="date" value={from}
              onChange={(e) => setFrom(e.target.value)}
              slotProps={{ inputLabel: { shrink: true } }} />
          </Grid>
          <Grid size={{ xs: 12, sm: 4 }}>
            <TextField fullWidth label="Hasta" type="date" value={to}
              onChange={(e) => setTo(e.target.value)}
              slotProps={{ inputLabel: { shrink: true } }} />
          </Grid>
          <Grid size={{ xs: 12, sm: 4 }}>
            <Button variant="contained" startIcon={<SearchIcon />}
              onClick={load} fullWidth>
              Analizar
            </Button>
          </Grid>
        </Grid>
      </Paper>

      {anomalies.length > 0 && (
        <Alert severity="warning" sx={{ mb: 2 }}>
          Se detectaron {anomalies.length} producto(s) con diferencias significativas
          entre consumo esperado y real.
        </Alert>
      )}

      {loading ? <LoadingSpinner /> : (
        <TableContainer component={Paper}>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell>Codigo</TableCell>
                <TableCell>Producto</TableCell>
                <TableCell>Unidad</TableCell>
                <TableCell align="right">Consumo Esperado</TableCell>
                <TableCell align="right">Consumo Real</TableCell>
                <TableCell align="right">Diferencia</TableCell>
                <TableCell align="right">% Diferencia</TableCell>
                <TableCell align="center">Estado</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {data.map((item: any) => (
                <TableRow key={item.productId} hover
                  sx={{
                    bgcolor: item.status !== 'NORMAL'
                      ? item.status === 'EXCESO' ? 'rgba(244,67,54,0.08)' : 'rgba(255,152,0,0.08)'
                      : undefined,
                  }}>
                  <TableCell>{item.productCode || '-'}</TableCell>
                  <TableCell sx={{ fontWeight: 500 }}>{item.productName}</TableCell>
                  <TableCell>{item.unit}</TableCell>
                  <TableCell align="right">{item.expectedConsumption}</TableCell>
                  <TableCell align="right">{item.actualConsumption}</TableCell>
                  <TableCell align="right" sx={{
                    color: item.difference > 0 ? 'error.main' : item.difference < 0 ? 'warning.main' : 'text.primary',
                    fontWeight: item.difference !== 0 ? 600 : 400,
                  }}>
                    {item.difference > 0 ? '+' : ''}{item.difference}
                  </TableCell>
                  <TableCell align="right" sx={{
                    fontWeight: item.percentDifference !== 0 ? 600 : 400,
                  }}>
                    {item.percentDifference > 0 ? '+' : ''}{item.percentDifference}%
                  </TableCell>
                  <TableCell align="center">
                    <Chip label={item.status} size="small"
                      color={getStatusColor(item.status) as any} />
                  </TableCell>
                </TableRow>
              ))}
              {data.length === 0 && (
                <TableRow>
                  <TableCell colSpan={8} align="center" sx={{ py: 4 }}>
                    No hay datos para el periodo seleccionado
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Box>
  );
};

export default Antitheft;
